import { render, staticRenderFns } from "./toolbar-element.vue?vue&type=template&id=887c4214&"
import script from "./toolbar-element.vue?vue&type=script&lang=js&"
export * from "./toolbar-element.vue?vue&type=script&lang=js&"
import style0 from "./toolbar-element.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports